import { Component, OnDestroy, OnInit, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { finalize, takeUntil } from 'rxjs/operators';

import { PageNames } from 'src/app/configs/page-names.enum';
import {
  BlackListsWithPaginationDto,
  BlackListsWithPaginationItem,
  GetEnumValuesDto,
} from 'src/app/core/api/models';
import { EventTypes } from 'src/app/core/constants/event-types';
import { UtilService } from 'src/app/core/services/util.service';
import { BlackListsService } from '../../../core/api/services/black-lists.service';
import { BaseIndexPageComponent } from '../../shared/base/components/base-index-page.component';
import { BaseIndexModule } from '../../shared/base/modules/base-index.module';
import { ExcelService } from './../../../core/api/services/excel.service';
import { BlackListFormComponent } from './black-list-form/black-list-form.component';

@Component({
  selector: 'app-black-list',
  templateUrl: './black-list.component.html',
  imports: [BaseIndexModule, BlackListFormComponent],
})
export class BlackListComponent
  extends BaseIndexPageComponent
  implements OnInit, OnDestroy
{
  //#region Properties
  pageName = PageNames.blackList;
  pageId: string = 'blackList';
  modelWithPagination$: Observable<BlackListsWithPaginationDto>;
  items$: Observable<Array<BlackListsWithPaginationItem>>;

  downloadLoading: boolean = false;
  idPropertyName = 'mobile';
  BlackListTypeEnumValues: GetEnumValuesDto[] = [];

  // Binding service endpoints
  protected currentService = inject(BlackListsService);
  paginationApiMethodName: string =
    this.currentService.blackListsGetBlackListsWithPagination.name;
  createGetApiMethodName: string = this.currentService.blackListsCreateGet.name;
  auditApiMethodName: string =
    this.currentService.blackListsGetBlackListAudits.name;

  //#endregion

  constructor(protected excelFileService: ExcelService) {
    super();
  }

  ngOnInit() {
    try {
      super.ngOnInit();
    } catch (error) {
      this.loggerService.logError(
        this.tagName,
        error,
        EventTypes.infrastructure
      );
    }
  }

  configTableColumns() {
    this.tableColumns = [
      {
        title: ``,
        name: '',
        hasSearch: false,
        noSorting: true,
        isCheckBox: true,
      },
      {
        title: this.localizer.mobile,
        name: 'mobile',
        hasSearch: true,
        dir: 'ltr',
      },
      {
        title: 'common.type',
        name: 'type',
        type: 'enum',
        enumName: 'BlackListType',
        hasSearch: true,
      },
      {
        title: this.localizer.createDate,
        name: 'created',
        hasSearch: true,
        type: 'dateTime',
      },
    ];
  }

  //#region Api

  // Delete
  baseDeleteApi(id: string) {
    //id == mobile

    this.unSubs();

    this.pageConfig.loading = true;
    this.lastSelectedItemId = id;

    this.currentService
      .blackListsDelete({ body: { mobile: id } })
      .pipe(this.basePipeOperators())
      .subscribe(this.baseDeleteObserver);
  }

  getEnumsValues() {
    this.getEnumValuesApi('BlackListType')
      .pipe(takeUntil(this.onDestroy$))
      .subscribe((values) => (this.BlackListTypeEnumValues = values));
  }

  deleteBlackListsApi(mobiles: string[]) {
    this.unSubs();

    this.pageConfig.loading = true;
    this.lastSelectedItemId = mobiles;

    this.currentService
      .blackListsDeleteBlackLists({ body: { mobiles: mobiles } })
      .pipe(
        this.basePipeOperators(),
        finalize(() => (this.selectedIds = []))
      )
      .subscribe(this.baseGroupDeleteObserver);
  }

  //Download

  downloadBlackListGetApi() {
    if (this.downloadLoading) return;

    this.excelFileService
      .excelCreateBlackListsExcelGet()
      .pipe(this.basePipeOperators())
      .subscribe((res) => {
        if (res) this.downloadBlackListPostApi();
      });
  }

  downloadBlackListPostApi() {
    this.unSubs();
    this.downloadLoading = true;

    this.excelFileService
      .excelCreateBlackListsExcelPost({
        body: {
          pageNumber: 1,
          pageSize: this.pageConfig.tableConfig.paginationModel.totalCount,
          comparisonObjects: this.comparisonObjects,
          orders: this.sortObject,
        },
      })
      .pipe(
        this.basePipeOperators(),
        finalize(() => (this.downloadLoading = false))
      )
      .subscribe((file) => {
        UtilService.downloadFile(file.data);
      });
  }

  //#endregion

  //#region call Actions

  onDelete(mobile: string) {
    let dialogResult = this.dialogService.confirmDialog({
      content: mobile,
      isConfirmDelete: true,
    });
    dialogResult.afterClosed().subscribe((result) => {
      if (result) {
        this.baseDeleteApi(mobile);
      }
    });
  }

  //#endregion

  //#region group Deletion
  callGroupDeletion() {
    this.deleteBlackListsApi(this.selectedIds);
  }

  //#endregion

  async checkSelectedItems() {
    if (!this.selectedIds?.length) return;

    let checkBoxes = await this.getAllCheckBoxesAsync();

    checkBoxes.forEach((element) => {
      const itemId = element.getAttribute('data-checkbox-id');
      if (this.selectedIds.includes(itemId))
        (element as HTMLInputElement).checked = true;
    });
  }
}
